export default __webpack_public_path__ + "static/media/lubi.7e1e486e.webp";